module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"sk":{"Test":"jadro i18n","Test2":"ooooo"}}')
  delete Component.options._Ctor
}
